"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupUpdate = exports.groupReset = exports.groupList = exports.groupFetch = exports.groupDelete = exports.groupCount = exports.groupAssignedList = exports.groupApiResponseSuccess = exports.groupApiResponseError = exports.groupAdd = void 0;
var _group = require("./group.constant");
// common success
var groupApiResponseSuccess = function groupApiResponseSuccess(actionType, data) {
  return {
    type: _group.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.groupApiResponseSuccess = groupApiResponseSuccess;
var groupApiResponseError = function groupApiResponseError(actionType, error) {
  return {
    type: _group.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * Get group count
 * @returns api response
 * @description this function used get group count.
 */
exports.groupApiResponseError = groupApiResponseError;
var groupCount = function groupCount(data) {
  return {
    type: _group.actionTypes.COUNT,
    payload: data
  };
};

/**
 * list
 * @returns api response
 * @description this function used get list.
 */
exports.groupCount = groupCount;
var groupList = function groupList(data) {
  return {
    type: _group.actionTypes.LIST,
    payload: data
  };
};

/**
 * list
 * @returns api response
 * @description this function used get list.
 */
exports.groupList = groupList;
var groupAssignedList = function groupAssignedList(data) {
  return {
    type: _group.actionTypes.ASSIGNED_LIST,
    payload: data
  };
};

/**
 * fetch
 * @returns api response
 * @description this function used fetch details.
 */
exports.groupAssignedList = groupAssignedList;
var groupFetch = function groupFetch(data) {
  return {
    type: _group.actionTypes.FETCH,
    payload: data
  };
};

/**
 * add
 * @returns api response
 * @description this function used add group.
 */
exports.groupFetch = groupFetch;
var groupAdd = function groupAdd(data) {
  return {
    type: _group.actionTypes.ADD,
    payload: data
  };
};

/**
 * update
 * @returns api response
 * @description this function used update group.
 */
exports.groupAdd = groupAdd;
var groupUpdate = function groupUpdate(data) {
  return {
    type: _group.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * delete
 * @returns api response
 * @description this function used delete group.
 */
exports.groupUpdate = groupUpdate;
var groupDelete = function groupDelete(data) {
  return {
    type: _group.actionTypes.DELETE,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset states.
 */
exports.groupDelete = groupDelete;
var groupReset = function groupReset(data) {
  return {
    type: _group.actionTypes.RESET,
    payload: data
  };
};
exports.groupReset = groupReset;